import { Avatar, For, HStack, Box, Flex, Card, Heading, Stack, Strong, Text, Button, Separator, ToggleTip } from "@chakra-ui/react"
import { LuAArrowUp, LuArrowBigLeft } from "react-icons/lu"
import { IoIosArrowForward } from "react-icons/io";
import ProfileService from "@/services/profile"
import _ from "lodash"
import { memo, useEffect, useState } from "react";
import { formatCurrency } from "@/utilities/number"
import { useAuth } from "contexts/auth";
import { useNavigate } from "react-router";
import { useStore } from "contexts/store";
import { useApp } from "contexts/app";



const MenuItem = ({ label, extra, onClick, showSeparator = true }) => {
    return (
        <>
            <div style={{ display: "flex", gap: 8 }} onClick={onClick}>
                <div style={{ flexShrink: 1, flexGrow: 1 }}>
                    <Text>{label}</Text>
                </div>
                <div>
                    <Text fontWeight={"semibold"}>{extra}</Text>
                </div>
                <div style={{ alignContent: "center" }}>
                    <IoIosArrowForward />
                </div>
            </div>
            {showSeparator && <Separator />}
        </>
    )
}


export default memo(MenuItem)